import {
    CREATE_PROCESS_REQUEST_DK,
    CREATE_PROCESS_SUCCESS_DK,
    CREATE_PROCESS_FAILURE_DK,
    DELETE_PROCESS_REQUEST_DK,
    DELETE_PROCESS_SUCCESS_DK,
    DELETE_PROCESS_FAILURE_DK,
    FETCH_SINGLE_PROCESS_REQUEST_DK,
    FETCH_SINGLE_PROCESS_SUCCESS_DK,
    FETCH_SINGLE_PROCESS_FAILURE_DK,
    FETCH_PROCESS_REQUEST_DK,
    FETCH_PROCESS_SUCCESS_DK,
    FETCH_PROCESS_FAILURE_DK,
    UPDATE_PROCESS_REQUEST_DK,
    UPDATE_PROCESS_SUCCESS_DK,
    UPDATE_PROCESS_FAILURE_DK,
    RESET_PROCESS_INFO_DK,
    CREATE_PROCESS_FORM_DK,
    UPDATE_PROCESS_FORM_DK,
    NAVIGATE_PROCESS_DK,
    NAVIGATE_PROCESS_DETAILS_DK,
    CREATE_ASSIGN_PROCESS_SUCCESS_DK,
    CREATE_ASSIGN_PROCESS_FAILURE_DK,
    CREATE_ASSIGN_PROCESS_REQUEST_DK,
    FETCH_ASSIGN_PROCESS_SUCCESS_DK,
    FETCH_ASSIGN_PROCESS_FAILURE_DK,
    FETCH_ASSIGN_PROCESS_STYLE_BY_ID_SUCCESS_DK,
    FETCH_ASSIGN_PROCESS_STYLE_BY_ID_REQUEST_DK,
    FETCH_ASSIGN_PROCESS_STYLE_BY_ID_FAILURE_DK,
    FETCH_PROGRAM_MAPPING_BY_PROCESS_ID_SUCCESS_DK,
    FETCH_PROGRAM_MAPPING_BY_PROCESS_ID_REQUEST_DK,
    FETCH_PROGRAM_MAPPING_BY_PROCESS_ID_FAILURE_DK,
    UPDATE_ASSIGN_PROCESS_SUCCESS_DK,
    FETCH_SINGLE_ASSIGN_PROCESS_SUCCESS_DK,
    DELETE_ASSIGN_PROCESS_SUCCESS_DK,
    RESET_ASSIGN_PROCESS_INFO_DK,
    CREATE_ASSIGN_PROCESS_FORM_DK,
    UPDATE_ASSIGN_PROCESS_FORM_DK,
    DELETE_ASSIGN_PROCESS_FAILURE_DK,
    FETCH_SINGLE_ASSIGN_PROCESS_FAILURE_DK,
    UPDATE_ASSIGN_PROCESS_FAILURE_DK,
    FETCH_ASSIGN_PROCESS_REQUEST_DK,
    DELETE_ASSIGN_PROCESS_REQUEST_DK,
    UPDATE_ASSIGN_PROCESS_REQUEST_DK,
    FETCH_SINGLE_ASSIGN_PROCESS_REQUEST_DK
} from './process.actionType';

export const PROCESS_DK = 'processMasterDK';

let initialState = {
    loading: false,
    processList: [],
    assignProcessList: [],
    assignProcessListById: [],
    programMappingByProcessIdList: [],
    processform: {},
    processAssignForm: {},
    selectedState: {},
    errorMessage: '',
    singleProcess: {},
    isProcessFlow: false,
    assignProcessStatus: ''
};

export let processDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_PROCESS_REQUEST_DK:
        case CREATE_ASSIGN_PROCESS_REQUEST_DK:
        case FETCH_ASSIGN_PROCESS_REQUEST_DK:
        case UPDATE_PROCESS_REQUEST_DK:
        case UPDATE_ASSIGN_PROCESS_REQUEST_DK:
        case FETCH_SINGLE_PROCESS_REQUEST_DK:
        case FETCH_SINGLE_ASSIGN_PROCESS_REQUEST_DK:
        case FETCH_ASSIGN_PROCESS_STYLE_BY_ID_REQUEST_DK:
        case FETCH_PROGRAM_MAPPING_BY_PROCESS_ID_REQUEST_DK:
        case DELETE_PROCESS_REQUEST_DK:
        case DELETE_ASSIGN_PROCESS_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_PROCESS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                processList: updatePayload
            };
        case FETCH_ASSIGN_PROCESS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                assignProcessList: updatePayload
            };
        case FETCH_ASSIGN_PROCESS_STYLE_BY_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                assignProcessListById: updatePayload
            };
        case FETCH_PROGRAM_MAPPING_BY_PROCESS_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                programMappingByProcessIdList: updatePayload
            };
        case CREATE_PROCESS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                processform: {}
            };
        case CREATE_ASSIGN_PROCESS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                processAssignForm: {},
                assignProcessStatus: updatePayload
            };
        case UPDATE_PROCESS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                processform: {}
            };
        case UPDATE_ASSIGN_PROCESS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                processAssignForm: {}
            };
        case FETCH_SINGLE_PROCESS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                processform: updatePayload
            };
        case FETCH_SINGLE_ASSIGN_PROCESS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                processAssignForm: updatePayload
            };
        case DELETE_PROCESS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                processform: {}
            };
        case DELETE_ASSIGN_PROCESS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                processAssignForm: {}
            };
        case RESET_PROCESS_INFO_DK:
            return {
                ...state,
                processform: {}
            };
        case RESET_ASSIGN_PROCESS_INFO_DK:
            return {
                ...state,
                processAssignForm: {}
            };
        case CREATE_PROCESS_FORM_DK:
        case UPDATE_PROCESS_FORM_DK:
            return {
                ...state,
                loading: false,
                processform: {
                    ...state.processform,
                    [payload.key]: payload.value
                }
            };
        case CREATE_ASSIGN_PROCESS_FORM_DK:
        case UPDATE_ASSIGN_PROCESS_FORM_DK:
            return {
                ...state,
                loading: false,
                processAssignForm: {
                    ...state.processAssignForm,
                    [payload.key]: payload.value
                }
            };
        case CREATE_PROCESS_FAILURE_DK:
            return {
                ...state,
                loading: false,
                assignProcessStatus: '404'
            };
        case CREATE_PROCESS_REQUEST_DK:
            return {
                ...state,
                loading: false,
                assignProcessStatus: ''
            };
        case FETCH_PROCESS_FAILURE_DK:
        case FETCH_ASSIGN_PROCESS_FAILURE_DK:
        case UPDATE_ASSIGN_PROCESS_FAILURE_DK:
        case CREATE_PROCESS_FAILURE_DK:
        case CREATE_ASSIGN_PROCESS_FAILURE_DK:
        case FETCH_SINGLE_PROCESS_FAILURE_DK:
        case FETCH_SINGLE_ASSIGN_PROCESS_FAILURE_DK:
        case FETCH_ASSIGN_PROCESS_STYLE_BY_ID_FAILURE_DK:
        case FETCH_PROGRAM_MAPPING_BY_PROCESS_ID_FAILURE_DK:
        case DELETE_PROCESS_FAILURE_DK:
        case DELETE_ASSIGN_PROCESS_FAILURE_DK:
            return {
                ...state,
                loading: false
            };
        case NAVIGATE_PROCESS_DETAILS_DK:
            return {
                ...state,
                isProcessFlow: true,
                singleProcess: updatePayload.singleProcess
            };
        case NAVIGATE_PROCESS_DK:
            return {
                ...state,
                isProcessFlow: false
            };
        default:
            return state;
    }
};
